import { Condition, EntitySearchType, formatTicker } from '@toggle/toggle';
import React from 'react';

import { useTagsSearch } from '~/hooks/use-tags-search/useTagsSearch';

import { ConditionSearch } from '../condition-search/ConditionSearch';
import styles from './ConditionAssetSearch.module.scss';
import { formatPrimaryMethod } from './utils';

export interface ConditionAssetSearchProps {
  condition: Condition;
  response: (editedPayload: Partial<Condition>) => void;
}

export const ConditionAssetSearch = ({
  condition,
  response,
}: ConditionAssetSearchProps) => {
  const isAssetNameMessage = (value: string) =>
    value.length < 16 && value.split(/\s+/).length < 3;

  const { tags: tagList, searchTags } = useTagsSearch({
    searchType: EntitySearchType.Entity,
    additionalConditionChecker: isAssetNameMessage,
  });

  return (
    <ConditionSearch
      label={condition.formattedTicker}
      dataTestId="scenario-asset-search"
      onChange={e => searchTags(e.target.value)}
    >
      {tagList.map(entity => {
        const handleSelect = () => {
          const ticker = formatTicker(entity);
          const editedCondition = {
            entity: entity.tag,
            entityName: entity.name,
            formattedTicker: ticker,
            snake: entity.default_snake,
            snakeName: formatPrimaryMethod(entity.primary_method),
          };
          response(editedCondition);
        };

        return (
          <div
            className={styles.item}
            key={entity.tag}
            onClick={handleSelect}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSelect();
              }
            }}
            role="option"
            aria-selected={entity.tag === condition.entity}
            tabIndex={0}
          >
            {entity.name_short}
          </div>
        );
      })}
    </ConditionSearch>
  );
};
